import { Day } from '../types/dayType';

export const daysOfWeek: { abbreviation: string; name: Day }[] = [
    { abbreviation: 'Mon', name: 'monday' },
    { abbreviation: 'Tues', name: 'tuesday' },
    { abbreviation: 'Wed', name: 'wednesday' },
    { abbreviation: 'Thurs', name: 'thursday' },
    { abbreviation: 'Fri', name: 'friday' },
    { abbreviation: 'Sat', name: 'saturday' },
    { abbreviation: 'Sun', name: 'sunday' },
] as const;

export const notesCharacterLimit = 1000;

export const maxExportUsers = 3;
